export default __webpack_public_path__ + "static/media/at.39bb8c6f.png";